export default __webpack_public_path__ + "static/media/star_calendar.025642d5.svg";